import React from 'react';

import { Button, Group, Modal, Stack, Text, Title } from '@mantine/core';

interface ICreationWarningModal {
  opened: boolean;
  handleConfirm: () => void;
  handleCancel: () => void;
}

const CreationWarningModal = ({
  opened,
  handleConfirm,
  handleCancel,
}: ICreationWarningModal): JSX.Element => {
  return (
    <Modal
      centered
      opened={opened}
      onClose={handleCancel}
      title={<Title order={4}>Warning</Title>}
      size='auto'
    >
      <Stack p='sm'>
        <Text>{`You have not added any billing plans. Are you sure you want to continue?`}</Text>
        <Group position='right' pt='sm'>
          <Button onClick={handleCancel} variant='subtle'>
            Cancel
          </Button>
          <Button onClick={handleConfirm}>Confirm</Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default CreationWarningModal;
